/**
 * 予約の mutations
 */
import deepmerge from 'deepmerge'
import * as C from '@/consts'
import { init } from './state'

export default {
  /**
   * book ストアを初期化する
   *
   * @param {State} state
   * @param {Object} settings 設定情報
   */
  init (state, settings) {
    const data = deepmerge(init, {
      initialized: true,
      station: settings.station
    })

    for (const k in data) {
      state[k] = data[k]
    }
  },

  /**
   * book ストアの初期化状態をクリアする
   *
   * @param {State} state
   */
  clear (state) {
    state.initialized = false
  },

  /**
   * 予約番号を設定する
   *
   * @param {State} state
   * @param {Number} reserveID 予約番号
   */
  setReserveID (state, reserveID) {
    state.reserveID = reserveID
    state.saved = true
  },

  /**
   * 予約可能期間を設定する
   *
   * @param {State} state
   * @param {Object} allow 予約可能期間
   */
  setAllow (state, allow) {
    state.allow = deepmerge(allow, {})
  },

  /**
   * 予約期間を設定する
   *
   * @param {State} state
   * @param {Object} schedule 予約期間
   */
  setSchedule (state, schedule) {
    if (!schedule) {
      state.schedule = {
        status: C.INPUT_NONE,
        begin: '',
        end: '',
        refer: ''
      }
    } else if (!schedule.end) {
      state.schedule = {
        status: C.INPUT_PENDING,
        begin: schedule.begin,
        end: schedule.begin,
        refer: schedule.refer
      }
    } else {
      state.schedule = {
        status: C.INPUT_RESOLVED,
        begin: schedule.begin,
        end: schedule.end,
        refer: schedule.refer
      }
    }
  },

  /**
   * 初期化時に車両を選択した場合に車両情報を設定する
   *
   * @param {State} state
   * @param {Object} car 車両情報
   */
  setChoosedCar (state, car) {
    state.choosedCar = true
    state.car = deepmerge(car, {})
  },

  /**
   * 車両情報を設定する
   *
   * @param {State} state
   * @param {Object} car 車両情報
   */
  setCar (state, car) {
    state.car = deepmerge(car, {})
  },

  /**
   * 期間情報を設定する
   *
   * @param {State} state
   * @param {Object} period 予約期間
   */
  setPeriod (state, period) {
    state.period = deepmerge(period, {})
  },

  /**
   * オプション群を設定する
   *
   * @param {State} state
   * @param {Array} options オプション群
   */
  setOptions (state, options) {
    state.options = deepmerge(options, [])
  },

  /**
   * 免責補償を設定する
   *
   * @param {State} state
   * @param {Object} insurance 免責補償
   */
  setInsurance (state, insurance) {
    state.insurance = deepmerge(insurance, { status: C.INPUT_RESOLVED })
  },

  /**
   * 送迎を設定する
   *
   * @param {State} state
   * @param {Object} pick 送迎
   */
  setPick (state, pick) {
    state.pick = deepmerge(pick, {})
  },

  /**
   * 配車を設定する
   *
   * @param {State} state
   * @param {Object} deli 配車
   */
  setDeli (state, deli) {
    state.deli = deepmerge(deli, {})
  },

  /**
   * 乗り捨て先を設定する
   *
   * @param {State} state
   * @param {Object} returns 乗り捨て先
   */
  setReturns (state, returns) {
    state.returns = deepmerge(returns, {})
  },

  /**
   * フライトを設定する
   *
   * @param {State} state
   * @param {Object} flights フライト
   */
  setFlights (state, flights) {
    state.flights = deepmerge(flights, {})
  },

  /**
   * 乗車人数を設定する
   *
   * @param {State} state
   * @param {Object} peoples 乗車人数
   */
  setPeoples (state, peoples) {
    state.peoples = peoples
  },

  /**
   * クーポンを設定する
   *
   * @param {State} state
   * @param {Object} coupon クーポン
   */
  setCoupon (state, coupon) {
    state.coupon = coupon ? deepmerge(coupon, {}) : null
  },

  /**
   * 連絡事項を設定する
   *
   * @param {State} state
   * @param {String} note 連絡事項
   */
  setNote (state, note) {
    state.note = note
  },

  /**
   * 支払方法を設定する
   *
   * @param {State} state
   * @param {String} pay 支払方法
   */
  setPay (state, pay) {
    state.pay = pay ? deepmerge(pay, {}) : null
  },

  /**
   * 料金情報を設定する
   *
   * @param {State} state
   * @param {Object} charge 料金情報
   */
  setCharge (state, chrage) {
    state.charge = chrage ? deepmerge(chrage, {}) : null
  }

}
